import { render, staticRenderFns } from "./month-page.vue?vue&type=template&id=4393b27e"
import script from "./month-page.vue?vue&type=script&lang=js"
export * from "./month-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports